var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvalidicon = function SvgInvalidicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    "aria-hidden": "true",
    viewBox: "1.5 1.5 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#523a3b",
    stroke: "#f47174",
    strokeLinejoin: "round",
    d: "m18.7 4.51-6-2.25c-.45-.17-.95-.17-1.4 0l-6 2.25C4.52 4.81 4 5.55 4 6.39v4.7c0 4.94 3.27 9.57 7.71 10.83.19.05.39.05.57 0C16.73 20.66 20 16.03 20 11.09v-4.7c0-.84-.52-1.58-1.3-1.88z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f47174",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m9.5 9.5 5 5m-5 0 5-5"
  })));
};
export default SvgInvalidicon;